export default __webpack_public_path__ + "4318c056221fc667ce8554e325462754.svg";